import React, { useRef, useState, useEffect } from "react";
import {
  Container,
  Box,
  makeStyles,
  createStyles,
  Theme,
  Grid,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";

import ResizeObserver from "resize-observer-polyfill";
import LaborFooter from "../../components/FooterComponents/LaborFooter";
import MobileFooter from "../../components/FooterComponents/MobileFooter";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    sectionRoot: {
      display: "flex",
      minHeight: "20vh",
      // backgroundColor: grey[100],
      // paddingLeft: 0,
      // paddingRight: 0,
    },
  })
);

interface FooterContainerProps {
  //   style: any;
}

function FooterContainer() {
  const classes = useStyles();
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down("xs"));
  const menuRef = useRef<any>(null);
  const [sliderSize, setSliderSize] = useState({
    left: 0,
    top: 0,
    width: 0,
    height: 0,
  });

  return (
    <Container
      maxWidth={false}
      className={classes.sectionRoot}
      disableGutters
      //   style={props.style}
    >
      <Container maxWidth={"lg"} disableGutters>
        <Grid
          container
          spacing={0}
          alignItems="center"
          justify="center"
          ref={menuRef}
        >
          {!matches ? <LaborFooter /> : <MobileFooter />}
        </Grid>
      </Container>
    </Container>
  );
}

export default FooterContainer;
